import React, { FC, useEffect, useContext } from 'react';
import EditList from 'Components/SmartList/EditList';
import UserDetailsContext from 'Context/userDetailsContext';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation } from '@apollo/react-hooks';
import { toastMessage } from 'Containers/Toast/actions';
import { useHistory } from 'Utils/router';
import { setNewListValue } from 'Containers/Filter/ListMembership/actions/listMembership.actions';
import withErrorBoundary from 'HOC/ErrorBoundary';
// eslint-disable-next-line camelcase
import { UpdateList_GQL } from './gqlQuery';

interface Props {
  closeModal?: () => void;
  id?: string;
  count?: number;
  redirect?: boolean;
}

const EditListContainer: FC<Props> = (props: Props) => {
  const Dispatch = useDispatch();
  const userDetails = useContext(UserDetailsContext);
  const [updateList, { loading, error, data }] = useMutation(UpdateList_GQL);
  const history = useHistory();

  const { closeModal, id, count, redirect } = props;

  const onSaveHandler = (e: string) => {
    updateList({
      variables: {
        inst_id: userDetails.instId,
        account_id: userDetails.accountId,
        id,
        name: e,
      },
    });
    setNewListValue(Dispatch, true);
  };

  useEffect(() => {
    if (data) {
      if (data.listUpdate.code >= 200 && data.listUpdate.code <= 299) {
        // Currently there is no pagination on list, use console to verify save //
        Dispatch(
          toastMessage({
            message: `${data.listUpdate.data.name} successfully updated`,
            position: 'bottom',
          })
        );
        closeModal();

        if (redirect) history.push('inquiries/lists');
      }
    }
  }, [data]);
  return (
    <EditList
      errorMessage={
        error &&
        JSON.parse(error.networkError.result.errors[0].message).serverResponse
          .message
      }
      disabled={loading || data}
      onCancel={closeModal}
      onSave={(text) => onSaveHandler(text)}
      matches={count}
    />
  );
};

EditListContainer.defaultProps = {
  closeModal: () => {},
  id: '',
  count: 0,
  redirect: false,
};

export default withErrorBoundary(EditListContainer);
